import type { IntegrationProvider } from '@/types/integrations'

function formatProviderCode(code: string): string {
  return code
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}

export function getProviderDisplayName(
  code: string,
  providers?: IntegrationProvider[] | null,
): string {
  const match = providers?.find((p) => p.code === code)
  if (match) return match.name
  return formatProviderCode(code)
}
